module.exports = __webpack_public_path__ + "img/gartek-services-fire-protection-stop-worrying.75877ea1.png";